<template>
	<div class="box-page">
		<i-modal ref="modalDetailPengiriman">
			<template v-slot:title>
				<div class="modal-title pl-3 font-size-12 font-size-sm-10 font-weight-bold">Detail Pengiriman</div>
			</template>
			<template v-slot:body>
				<DetailReceipt></DetailReceipt>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalDetailPenukaran" class="modal-large">
			<template v-slot:title>
				<div class="modal-title pl-3 font-size-12 font-size-sm-10 font-weight-bold">Detail Penukaran</div>
			</template>
			<template v-slot:body>
				<div class="col-12 font-size-11 pb-4 pl-0 pr-0 pl-md-3 pr-md-3" v-if="Object.values(detailConvert).length > 0">
					<div class="col-12 pl-0 pr-0">
						<div class="col-12 col-md-12 pl-0">
							<div class="col-12 pl-0 pr-0 text-center code-detail-product font-size-12 font-size-sm-10 font-weight-bold mb-3">
								Detail Data
							</div>
							<div class="row pl-0">
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Kode</div>
									<div>{{ detailConvert.serial_convert_code }}</div>
								</div>
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Status</div>
									<div>{{ detailConvert.serial_convert_status_text }}</div>
								</div>
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Tanggal Penukaran</div>
									<div>{{ detailConvert.serial_convert_datetime | toTanggal }}</div>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-12 pl-0 pr-0 font-size-10 mt-4">
							<div class="col-12 pl-0 pr-0 text-center code-detail-product font-size-12 font-size-sm-10 font-weight-bold mb-3">
								Detail Produk
							</div>
                            <div class="col-12 pl-0 pr-0 d-flex flex-wrap mb-2">
								<div class="col-3 pl-0 font-size-12">Produk Asal</div>
								<div class="col-3 pl-0 font-size-12">Serial Asal</div>
								<div class="col-3 pl-0 font-size-12">Produk Tujuan</div>
								<div class="col-3 pl-0 font-size-12">Serial Tujuan</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap mt-1" v-for="(product, index) in detailConvert.serial_convert_detail" :key="index">
								<div class="col-3 pl-0 color-gray-2">{{product.serial_convert_detail_from_product_code}}</div>
								<div class="col-3 pl-0 color-gray-2">{{product.serial_convert_detail_from_serial ? product.serial_convert_detail_from_serial : '-'}}</div>
								<div class="col-3 pl-0 color-gray-2">{{product.serial_convert_detail_to_product_code}}</div>
								<div class="col-3 pl-0 color-gray-2">{{product.serial_convert_detail_to_serial ? product.serial_convert_detail_to_serial : '-' }}</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alert" type="alert" @remove="$refs.modalAlert.modalHide()"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmation.modalHide()" @confirm="confirmDelivery"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
					<div class="col-12 col-md-8 col-lg-9 pl-0 mt-auto mb-auto">
						<div class="col-12 pl-1 font-size-12 font-size-sm-10">Penukaran Serial</div>
						<div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">List Penukaran Serial</div>
					</div>
					<div class="col-7 col-md-4 col-lg-3 pl-0 pr-0 pt-2 pt-md-0 mt-auto mb-auto d-flex justify-content-end">
					</div>
				</div>
			</div>
			<div class="col-12 pl-0 pr-0">
				<div class="row" v-if="listConvertSerial.length == 0">
					<div class="col-12 pr-0 d-flex">
						<div class="col-4 pl-0 pt-3" v-for="(index) in 3" :key="index">
							<div class="col-12 pt-3 pb-3 rounded-cus cus-box-shadow bg-white">
								<vcl :width='300' :height='135'>
									<rect x="5" y="4" rx="2" ry="2" width="40" height="30" />
									<rect x="5" y="51" rx="2" ry="2" width="75" height="12" />
									<rect x="5" y="71" rx="2" ry="2" width="120" height="12" />
									<rect x="5" y="101" rx="2" ry="2" width="75" height="12" />
									<rect x="5" y="121" rx="2" ry="2" width="120" height="12" />
									<rect x="255" y="104" rx="2" ry="2" width="40" height="30" />
								</vcl>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-else-if="listConvertSerial == 'error'">
					<div class="col-12 pr-0 d-flex flex-wrap">
						<div class="col-12 pl-0 pt-3">
							<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow">
								<div class="col-12 text-center">
									<div class="col-6 col-md-3 ml-auto mr-auto">
										<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
									</div>
									<div class="font-size-11 pt-1">Data tidak tersedia!</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-else>
					<div class="col-12 pr-0 d-flex flex-wrap">
						<div class="col-12 col-md-6 col-lg-4 pl-0 pt-3" v-for="convertSerial in listConvertSerial" :key="convertSerial.serial_convert_id">
							<div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
								<div class="col-3 pt-2 pl-2 pr-2">
									<div class="col-12 pl-0 pr-0">
										<span class="icon font-size-20 color-blue"><i class="fas fa-exchange-alt"></i></span>
									</div>
								</div>
								<div class="col-9 pt-2 pl-2 pr-2 text-right">
									<div class="col-12 pl-0 pr-0">
										{{ convertSerial.serial_convert_status_created_datetime | toTanggal }}
									</div>
								</div>
								<div class="col-12 pt-3 pl-2 pr-2">
									<div class="font-size-11 color-gray-2">Kode Penukaran</div>
									<div class="pt-1 font-size-12 font-weight-bold color-blue cursor-pointer" @click="getDetail(convertSerial)" data-toggle="tooltip" title="Detail Penukaran">
										<span class="mr-2"><img src="/assets/report/icon-details.svg"></span>
										{{ convertSerial.serial_convert_code }}
									</div>
								</div>
								<div class="col-12 pt-3 pl-2 pr-2">
									<div class="font-size-11 color-gray-2">Status</div>
									<div class="pt-1 font-size-12 font-weight-bold cursor-pointer d-flex justify-content-between" :class="convertSerial.serial_convert_status == 'approved' ? 'color-green' : 'color-orange'">
										<div>{{ convertSerial.serial_convert_status_text ? convertSerial.serial_convert_status_text : convertSerial.serial_convert_status_text }}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pt-3 pl-2 pr-2 text-center">
							<i-pagination :limit = 'limit' @changeLimit="changeLimit($event)" :pagination = 'pagination' @gotoPage="gotoPage($event)" @refresh="refresh($event)"></i-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IModal from '@/components/IModal.vue';
import IPagination from '@/components/IPagination.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import DetailReceipt from '@/views/receipt/component/DetailReceipt.vue';

export default {
	components: {
		IPagination, IModal, AlertModal, DetailReceipt
	},
	data() {
		return {
			limit : 10,
			page: 1,
			camera: 'front',
			noRearCamera: false,
			noFrontCamera: false,
			alert: '',
			confirmMessage: '',
            detailConvert: {},
		}
	},
	computed: {
		...mapState('serial', ['listConvertSerial', 'pagination']),
	},
	methods: {
		...mapActions('serial', ['getListConvertSerial']),

		gotoPage(val) {
			this.page = val
			this.getListConvertSerial({page: this.page, limit : this.limit})
		},
		refresh(val) {
			this.page = val
			this.getListConvertSerial({page: this.page, limit : this.limit})
		},
		changeLimit(val) {
			this.page = 1
			this.limit = val
			this.getListConvertSerial({page: this.page, limit : this.limit})
		},
		async getDetail(data) {
            this.detailConvert = data
			this.$refs.modalDetailPenukaran.modalShow()
		},
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Penukaran Serial');
		this.getListConvertSerial({page: this.page, limit : this.limit})
	}
};
</script>